import React, { useEffect, useState } from 'react';
import { BottomSheet } from '../../../../app/common/sharedComponents/BottomSheet';
import { FiltersContent } from '../../../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import {
  BottomSheetButtonSpacing,
  CalendarIconContainer,
  FilterModalHeaderContainer,
  InputContainer,
  MyAuditDatePickerContainer,
  StatusRadioAssessedWrapper,
  StatusRadioCreatedByWrapper,
  StatusRadioReceivedWrapper,
} from '../../MyAudit/MyAuditList/styled.myAuditList';
import { useTranslation } from 'react-i18next';
import { Body5 } from '../../../../app/common/typography';
import { DatePickerWrapper } from '../../../../app/common/sharedStyledComponents/Datepicker.styled';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { CloseCircleDark } from '../../../../app/common/icons/CloseCircleDark';
import { Calendar } from '../../../../app/common/icons/Calendar';
import { DropdownSingle } from '../../../../app/common/sharedComponents/DropdownSingle';
import { ButtonLarge } from '../../../../app/common/sharedComponents/buttons/ButtonLarge';
import { IDropdownOption } from '../../../../app/@types/dropdown';
import { getDepartmentApi } from '../../../../components/SelfAssessmentAssignDepartment/apiCaller';
import { showErrorMessage } from '../../../../helpers/showMessage';
import { ActionPlanStatus } from '../../../../enums/ActionPlanStatus';
import { FilterInputContainer } from '../../../../components/SelfAssessments/styled.SelfAssessment';
import { userHotelDetails } from '../../../../helpers/handleBrandAndHotelData';
import { SearchBoxUser } from './SearchBoxUser';
import { SearchBoxContainsUsers } from './SearchBoxContainsUser';
import { convertMultiUserLogicForAP } from '../../../../helpers/makeActionPlanListFilter';
import {
  IActionPlanFilter,
  IFocusAreaOptions,
} from '../../../../app/@types/actionPlanList';
import { Event } from '../../../../enums/labels/Event';
import { sentryReport } from '../../../../helpers/sentry';
import { LevelTypes } from '../../../../enums/Level';
import {
  FilterContentWrapper,
  FilterLabelWrapper,
} from './actionPlanList.styled';
import { RadioButton } from '../../../common/sharedComponents/RadioButton';

interface ActionPlanListFilterProps {
  isBottomSheetOpen: boolean;
  setBottomSheetOpen: (value: boolean) => void;
  handleFilter: () => void;
  clearFilter: () => void;
  updateFilter: (key, value) => void;
  filter: IActionPlanFilter;
}
export function ActionPlanListFilter ({
  isBottomSheetOpen,
  setBottomSheetOpen,
  handleFilter,
  clearFilter,
  updateFilter,
  filter,
}: ActionPlanListFilterProps) {
  const { t } = useTranslation();
  const { userData } = userHotelDetails();
  const [filterType, setFilterType] = useState<string | null>(
    filter.listFilterType
  );
  const [focusAreaOptions, setFocusAreaOptions] = useState<IFocusAreaOptions>();
  const lowerLevels: LevelTypes[] = ['staff', 'teamLead'];
  const isDisabled = lowerLevels.includes(userData.user.level);

  useEffect(() => {
    getDepartmentApi()
      .then((resp) => {
        delete resp.data;
        setFocusAreaOptions({ categories: Object.values(resp) });
      })
      .catch((error) => {
        sentryReport(error.response.data, error.message, error.code, {
          alertMessage: t(
            'COMMON.ALERT_MESSAGES.UNABLE_TO_GET_DEPARTMENT_LIST_FOR_FILTERS'
          ),
          method: getDepartmentApi,
        });
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_DEPARTMENT_LIST_FOR_FILTERS')
        );
      });
  }, []);

  const statusOptions: IDropdownOption[] = [
    { label: 'Open', value: ActionPlanStatus.open },
    { label: 'Awaiting Approval', value: ActionPlanStatus.awaitingApproval },
    { label: 'Rejected', value: ActionPlanStatus.rejected },
    { label: 'Approved', value: ActionPlanStatus.complete },
  ];

  const handleCallBackSelectedOptionsSelectedUser = (selected) => {
    updateFilter('selectedUser', selected);
  };

  function handleContainsUsersSearchValue (selected) {
    updateFilter('cond', selected.logic);
    updateFilter('containsUsers', selected.list);
  }

  const getDefaultOption = (filter, focusAreaOptions: IFocusAreaOptions) => {
    if (
      filter.categoryIds &&
      filter.categoryIds.length &&
      focusAreaOptions &&
      focusAreaOptions.categories
    ) {
      const matchingCategory = focusAreaOptions.categories.find(
        ({ sourceTemplateCategoryId }) =>
          // tslint:disable-next-line:triple-equals
          sourceTemplateCategoryId == filter.categoryIds[0]
      );

      if (matchingCategory) {
        return {
          label: matchingCategory.value,
          value: filter.categoryIds[0],
        };
      }
    }
    return null;
  };

  const getOptions = (focusAreaOptions: IFocusAreaOptions) => {
    if (focusAreaOptions && focusAreaOptions.categories) {
      return focusAreaOptions.categories.map((category) => ({
        label: category.value,
        value: category.sourceTemplateCategoryId.toString(),
        category: category.categoryType,
      }));
    }
    return [];
  };

  return (
    <BottomSheet
      isOpen={isBottomSheetOpen}
      onClose={() => {
        setBottomSheetOpen(false);
      }}
      title={t('COMMON.ACTION_PLAN.BUTTON.FILTER')}
    >
      <FiltersContent>
        <FilterModalHeaderContainer>
          <StatusRadioReceivedWrapper checked={filterType === Event.received}>
            <RadioButton
              checked={filterType === Event.received}
              label={t('COMMON.ACTION_PLAN.LABEL.RECEIVED')}
              onClick={() => {
                updateFilter('listFilterType', Event.received);
                setFilterType(Event.received);
              }}
            />
          </StatusRadioReceivedWrapper>
          <StatusRadioCreatedByWrapper checked={filterType === Event.sent}>
            <RadioButton
              checked={filterType === Event.sent}
              label={t('COMMON.ACTION_PLAN.LABEL.CREATED_BY')}
              onClick={() => {
                updateFilter('listFilterType', Event.sent);
                setFilterType(Event.sent);
              }}
            />
          </StatusRadioCreatedByWrapper>
          <StatusRadioAssessedWrapper checked={filterType === Event.both}>
            <RadioButton
              checked={filterType === Event.both}
              label={t('COMMON.MY_ACTIONS.SELECTOR.BOTH')}
              onClick={() => {
                setFilterType(Event.both);
                updateFilter('listFilterType', Event.both);
              }}
            />
          </StatusRadioAssessedWrapper>
        </FilterModalHeaderContainer>
        <FilterInputContainer>
          <SearchBoxUser
            callBackSelectedOptions={handleCallBackSelectedOptionsSelectedUser}
            selectedUser={filter.selectedUser || []}
            disabled={isDisabled}
          />
        </FilterInputContainer>
        <FilterContentWrapper>
          <SearchBoxContainsUsers
            callBackSelectedOptions={handleContainsUsersSearchValue}
            selectedUsers={filter.containsUsers || []}
            clearFilter={false}
            selectedAndOrOption={convertMultiUserLogicForAP(filter.cond)}
          />
        </FilterContentWrapper>
        <FilterContentWrapper>
          <FilterLabelWrapper>
            <Body5 color="eerieBlack">
              {t('COMMON.ACTION_PLAN.LABEL.FIND_DEPARTMENT')}
            </Body5>
          </FilterLabelWrapper>
          {focusAreaOptions && (
            <DropdownSingle
              isSearchable={false}
              defaultOption={getDefaultOption(filter, focusAreaOptions)}
              callback={(event) => updateFilter('categoryIds', [event.value])}
              options={getOptions(focusAreaOptions)}
            />
          )}
        </FilterContentWrapper>
        <FilterContentWrapper>
          <FilterLabelWrapper>
            <Body5 color="eerieBlack">
              {t('COMMON.ACTION_PLAN.LABEL.DATE_RANGE')}
            </Body5>
          </FilterLabelWrapper>
          <MyAuditDatePickerContainer>
            <InputContainer>
              <DatePickerWrapper>
                <DatePicker
                  className={`myaudit-filter-date-picker`}
                  popperClassName="date-picker-popper"
                  dateFormat="dd-MM-yyyy"
                  onFocus={(e) => e.target.blur()}
                  placeholderText="Start Date"
                  selected={filter.startDate}
                  onChange={(selectedDate) => {
                    if (selectedDate) {
                      updateFilter('startDate', selectedDate);
                      // setStartDate(selectedDate);
                    }
                  }}
                  maxDate={filter.endDate}
                />
              </DatePickerWrapper>
              <CalendarIconContainer>
                {filter.startDate ? (
                  <CloseCircleDark
                    onClick={() => updateFilter('startDate', undefined)}
                  />
                ) : (
                  <Calendar />
                )}
              </CalendarIconContainer>
            </InputContainer>
            <InputContainer>
              <DatePickerWrapper>
                <DatePicker
                  className={`myaudit-filter-date-picker`}
                  popperClassName="date-picker-popper"
                  dateFormat="dd-MM-yyyy"
                  minDate={filter.startDate}
                  onFocus={(e) => e.target.blur()}
                  placeholderText="End Date"
                  selected={filter.endDate}
                  onChange={(selectedDate) => {
                    if (selectedDate) {
                      updateFilter('endDate', selectedDate);
                    }
                  }}
                />
              </DatePickerWrapper>
              <CalendarIconContainer>
                {filter.endDate ? (
                  <CloseCircleDark
                    onClick={() => updateFilter('endDate', undefined)}
                  />
                ) : (
                  <Calendar />
                )}
              </CalendarIconContainer>
            </InputContainer>
          </MyAuditDatePickerContainer>
        </FilterContentWrapper>
        <FilterLabelWrapper>
          <Body5 color="eerieBlack">
            {t('COMMON.ACTION_PLAN.LABEL.STATUS')}
          </Body5>
        </FilterLabelWrapper>
        <FilterContentWrapper>
          {filter.status !== '' ? (
            <DropdownSingle
              options={statusOptions}
              defaultOption={statusOptions.find(
                (option) => option.value === filter.status
              )}
              menuPlacement="top"
              callback={(event) => {
                updateFilter('status', event.value);
              }}
            />
          ) : (
            <DropdownSingle
              defaultOption={null}
              options={statusOptions}
              menuPlacement="top"
              callback={(event) => {
                updateFilter('status', event.value);
              }}
            />
          )}
        </FilterContentWrapper>
        <BottomSheetButtonSpacing>
          <ButtonLarge
            title={t('COMMON.MY_AUDIT.BUTTON.SHOW_RESULTS')}
            onClick={handleFilter}
          />
          <ButtonLarge
            outlined={true}
            inverted={true}
            backgroundColor={'eerieBlack'}
            title={t('COMMON.MY_AUDIT.BUTTON.CLEAR_FILTERS')}
            onClick={clearFilter}
          />
        </BottomSheetButtonSpacing>
      </FiltersContent>
    </BottomSheet>
  );
}
